import { render, staticRenderFns } from "./CFriendlyCaptcha.vue?vue&type=template&id=c251d35a&scoped=true&"
import script from "./CFriendlyCaptcha.vue?vue&type=script&lang=js&"
export * from "./CFriendlyCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./CFriendlyCaptcha.vue?vue&type=style&index=0&id=c251d35a&scoped=true&lang=css&"
import style1 from "./CFriendlyCaptcha.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c251d35a",
  null
  
)

export default component.exports